/**
 * Removes leading and trailing quotes from a string
 * @param str - The input string to process
 * @returns The string with quotes removed, or empty string if input is undefined
 */
export const stripLeadingTrailingQuotes = (str?: string) => {
  return !str ? "" : str.replace(/^"|"$/g, "");
};
